class WelcomeOfferEmailForm extends HTMLElement {
  constructor() {
    super();
    this.onSubmit = this.onSubmit.bind(this);
  }

  connectedCallback() {
    this.form = this.querySelector('form');
    this.feedback = this.querySelector('.response-message');
    this.emailInput = this.querySelector('#wof-email') || this.querySelector('input[type="email"]');

    if (!this.form) {
      console.warn('No <form> inside <welcome-offer-email-form>');
      return;
    }

    // Clear error state when user types
    if (this.emailInput) {
      this.emailInput.addEventListener('input', () => {
        this.emailInput.removeAttribute('aria-invalid');
        this.clearFeedback();
      });
    }

    this.form.addEventListener('submit', this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.onSubmit);
  }

  async onSubmit(event) {
    event.preventDefault();
    this.clearFeedback();

    const emailInput = this.emailInput || this.querySelector('input[type="email"]');
    if (!emailInput) {
      this.showFeedback('Email field is missing', true);
      return;
    }

    const email = emailInput.value.trim();
    if (!this.isValidEmail(email)) {
      this.showFeedback('Please enter a valid email address.', true);
      // Mark field as invalid and focus it
      emailInput.setAttribute('aria-invalid', 'true');
      emailInput.focus();
      return;
    }

    const apiKey = this.getAttribute('api-key');
    const listId = this.getAttribute('list-id');

    const payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'Welcome Offer 2025',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email,
                subscriptions: {
                  email: { marketing: { consent: 'SUBSCRIBED' } },
                },
              },
            },
          },
        },
        relationships: { list: { data: { type: 'list', id: listId } } },
      },
    };

    try {
      const res = await fetch(`https://a.klaviyo.com/client/subscriptions?company_id=${apiKey}`, {
        method: 'POST',
        headers: {
          Accept: 'application/vnd.api+json',
          'Content-Type': 'application/vnd.api+json',
          Revision: '2025-04-15',
        },
        body: JSON.stringify(payload),
      });

      if (!res.ok) {
        const errText = await res.text();
        console.error('Subscription failed:', errText);
        this.showFeedback('Subscription failed. Please try again.', true);
        emailInput.setAttribute('aria-invalid', 'true');
        emailInput.focus();
        return;
      }

      // Optional: give immediate, polite confirmation before opening the panel
      this.showFeedback('Subscribed! Unlocking offer…', false);

      setTimeout(() => {
        const panel = document.querySelector('welcome-offer-panel');
        if (panel?.open) {
          panel.open(this);
          this.clearFeedback();
        }
        // Reset field for keyboard users
        emailInput.value = '';
        emailInput.removeAttribute('aria-invalid');
        emailInput.focus(); // or move focus into the opened panel if it traps focus
      }, 400);
    } catch (err) {
      console.error('Network error:', err);
      this.showFeedback('Network error, please try again.', true);
      emailInput.setAttribute('aria-invalid', 'true');
      emailInput.focus();
    }
  }

  showFeedback(message, isError) {
    if (!this.feedback) return;
    this.feedback.textContent = message;
    this.feedback.classList.toggle('error', !!isError);

    // If you want errors to interrupt screen readers, switch to assertive:
    // this.feedback.setAttribute('aria-live', isError ? 'assertive' : 'polite');
  }

  clearFeedback() {
    if (!this.feedback) return;
    this.feedback.textContent = '';
    this.feedback.classList.remove('error');
    // Keep role/status so the next message is announced
  }

  isValidEmail(email) {
    // Keep it simple; server does the real validation
    return /\S+@\S+\.\S+/.test(email);
  }
}

customElements.define('welcome-offer-email-form', WelcomeOfferEmailForm);
